<template>
    <span v-html="displayValue"></span>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
    props: {
        field: {
            type: String,
            validator: (prop) => ['full', 'original', 'plan', 'lowest_before'].includes(prop),
        },
        type: {
            default: 'soft',
            validator: (prop) => ['hard', 'soft'].includes(prop),
        },
    },
    computed: {
        ...mapState(['currency', 'enforceHardDisplay']),
        ...mapGetters(['product']),
        displayValue() {
            if (window.App.isIosView && this.product.price[this.field]) {
                if (this.field === 'full' && this.product.price.iosview?.newPrice) {
                    return this.getIosviewDisplayValue('newPrice');
                } else if (this.field === 'original' && this.product.price.iosview?.oldPrice) {
                    return this.getIosviewDisplayValue('oldPrice');
                }
            }
            return this.product.price[this.field]
                ? this.product.price[this.field].display_value[this.enforceHardDisplay ? 'hard' : this.type].replace(
                      ' ',
                      '&nbsp;',
                  )
                : null;
        },
    },
    methods: {
        getIosviewDisplayValue(iosviewPriceField) {
            // format numbers with decimal parts to 2 decimal places
            const hasDecimalPart = this.product.price.iosview[iosviewPriceField].price % 1 !== 0;
            return (
                this.product.price.iosview.currencySymbol +
                this.product.price.iosview[iosviewPriceField].price.toLocaleString(undefined, {
                    minimumFractionDigits: hasDecimalPart ? 2 : 0,
                }) +
                this.product.price.iosview.currency
            );
        },
    },
    watch: {
        currency: function () {
            // Add additional class old price if long price version
            if (
                this.currency === 'NZD' ||
                this.currency === 'AUD' ||
                this.currency === 'CAD' ||
                this.currency === 'SGD'
            ) {
                var divs = document.querySelectorAll('.old_price');
                for (var i = 0; i < divs.length; i++) {
                    divs[i].classList.add('long-currency');
                }
            }
        },
    },
};
</script>
